export {default} from 'netxcore@netx/core-app/controller';

////////////////////////////////////
// Deferred module loaders
////////////////////////////////////
// These are all core defined deferred modules
// If themes choose to create new deferred module they will need to set up their own dispatchers and routes accordingly
// and in the same pattern as seen here
// These are placed here for optimal bundle creations.
/**
 * @event module:netx#netx:load:module:adBuilder
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:adBuilder', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-ad-builder" */ '@netx/core-ad-builder'
	).then((AdBuilder) => {
		dispatcher.trigger('netx:load:deferred:module', AdBuilder.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:audioeditor
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:audioeditor', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-audio-editor" */ '@netx/core-audio-editor'
	).then((AudioEditor) => {
		dispatcher.trigger('netx:load:deferred:module', AudioEditor.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:dataset
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:dataset', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-data-set" */ '@netx/core-data-set'
	).then((DataSet) => {
		dispatcher.trigger('netx:load:deferred:module', DataSet.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:pdfViewer
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:pdfViewer', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-pdf-viewer" */ '@netx/core-pdf-viewer'
	).then((PDFViewer) => {
		dispatcher.trigger('netx:load:deferred:module', PDFViewer.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:imageeditor
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:imageeditor', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-image-editor" */ '@netx/core-image-editor'
	).then((ImageEditor) => {
		dispatcher.trigger('netx:load:deferred:module', ImageEditor.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:project
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:project', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-project" */ '@netx/core-project'
	).then((Project) => {
		dispatcher.trigger('netx:load:deferred:module', Project.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:stat
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:stat', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-stat-next" */ '@netx/core-stat-next'
	).then((Stat) => {
		dispatcher.trigger('netx:load:deferred:module', Stat.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:system
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system', function (opts, cb) {
	import(/* webpackChunkName: "@netx/core-system" */ '@netx/core-system').then(
		(System) => {
			dispatcher.trigger('netx:load:deferred:module', System.default, opts);
		},
	);
});
/**
 * @event module:netx#netx:load:module:uploadAssetRequestManager
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:system:groups', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-system-groups" */ '@netx/core-system-groups'
	).then((SystemGroups) => {
		dispatcher.trigger('netx:load:deferred:module', SystemGroups.default, opts);
	});
});
/**
 * @event module:netx#netx:load:module:videoeditor
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:videoeditor', function (opts, cb) {
	import(
		/* webpackChunkName: "@netx/core-video-editor" */ '@netx/core-video-editor'
	).then((VideoEditor) => {
		dispatcher.trigger('netx:load:deferred:module', VideoEditor.default, opts);
	});
});

/**
 * @event module:netx#netx:load:module:uploadAssetRequestManager
 * @param {object} opts Options
 * @fires module:netx#netx:load:module
 */
dispatcher.on('netx:load:module:uploadAssetRequestManager', function (opts) {
	import(
		/* webpackChunkName: "@netx/core-upload-asset-request-manager" */ '@netx/core-upload-asset-request-manager'
	).then((UploadAssetRequestManager) => {
		dispatcher.trigger(
			'netx:load:deferred:module',
			UploadAssetRequestManager.default,
			opts,
		);
	});
});

////////////////////////////////////
// !Deferred module loaders
////////////////////////////////////

/**
 * App Module Extensions
 * @event module:app#app:extend
 */
dispatcher.once('app:extend', function (NS) {
	/**
	 * @event module:netx#routed
	 */
	dispatcher.on('routed', function () {
		// Kills things (like dropdowns and the like)
		NS.$body.click();
	});

	// App shortcuts to the upload module
	// We only load upload after login and if the user is importer or above
	// so the app menus may have been parsed before the actions/translations
	// from upload are available
	// When we reqork our menu system we should factor this in and have some sort
	// of attribute that defines the menu's actions belong to another module and to not
	// parse/render the menu until that module has loaded
	dispatcher.on('app:upload', function (viewOptions, catId) {
		dispatcher.trigger('upload:landing', viewOptions, catId);
	});

	dispatcher.on('app:upload:attributeData', function () {
		//dispatcher.trigger('upload:attributeData');
		dispatcher.trigger('app:upload', {
			tab: 'attributeData',
		});
	});
	dispatcher.on('app:upload:bulkCartLoader', function () {
		//dispatcher.trigger('upload:bulkCartLoader');
		dispatcher.trigger('app:upload', {
			tab: 'bulkCartLoader',
		});
	});

	////////////////////////////
	// Drag Events
	////////////////////////////
	// For the love of bubbling events
	// Prevent the browser from trying to interpret these things
	NS.$document
		.off('dragover')
		// Bubbles up from drop zones within
		.on('dragover', 'body', function (e) {
			// Prevent
			e.preventDefault();
			return false;
		})
		// Bubbles up from drop zones within
		.off('drop')
		.on('drop', 'body', function (e) {
			// Prevent
			e.preventDefault();
			return false;
		});

	//DAM-4150 - override FormValidation.i18n for dynamic message
	FormValidation.I18n = $.extend(true, FormValidation.I18n || {}, {
		en_US: {
			stringLength: {
				less: 'Please enter no more than %s character(s)',
				// this doesn't work
				less_plural: 'Please enter no more than %s characters',
			},
		},
	});
}); // app:extend
